// =============================================================================
// Public API Client — usato dal wizard /book/:tenantSlug e dal widget embed
// =============================================================================
// Volutamente separato da `apiClient`: niente Authorization, niente x-tenant-id
// (il tenant è risolto dallo slug in URL), niente intercettori 401 → /login.
// Non condivide istanza con il client admin per evitare leak accidentali.
// =============================================================================

import axios from 'axios';

// Stesso baseURL del client admin per coerenza. In produzione l'API è raggiungibile
// da entrambi i domini (admin + widget host) grazie al CORS dual-mode.
const API_BASE_URL =
  (import.meta as unknown as { env?: Record<string, string> }).env?.VITE_API_URL ??
  'http://localhost:3000/api/v1';

export const publicApiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

export default publicApiClient;
